import React from 'react';
import DropdownInput from './DropdownInput';
import DropdownStandard from './DropdownStandard';

const Dropdown = () => {
  return <React.Fragment />;
};

Dropdown.Input = DropdownInput;
Dropdown.Standard = DropdownStandard;

export default Dropdown;
